/**
 * Cookie that stores the visitor's choice, as a JSON object of categories (see `CookieConsentType`), like the cookie
 * banner of the Business Navigator does. index.html reads it too: keep both in sync.
 */
export const CONSENT_COOKIE_NAME = "mp_cookies_consent";

/** Days the choice is kept before the banner asks again */
export const CONSENT_COOKIE_LIFETIME_DAYS = 30;

/** Cookies set by Google Analytics: the first-party ones are "_ga" and "_ga_<measurement id without G->" */
export const ANALYTICS_COOKIE_PATTERN = /^_ga(_.+)?$/;
